import React from "react";

import Button from "@/components/botanic/Button";

const DoctorClaimPanel: React.FC = () => (
  <div className="container my-section">
    <h2 className="mb-xs">Is this your medical practice?</h2>
    <p className="mb-md max-w-[400px]">
      It's easy to set up your profile! Once you do, you can receive appointment
      requests from patients nearby who are interested in medical marijuana.
    </p>
    <Button href="https://success.leafly.com/claim-your-practice">
      claim your practice
    </Button>
  </div>
);

export default DoctorClaimPanel;
